exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".value-container span[data-v-81b82960]{-webkit-transition:background-color .5s;transition:background-color .5s;background-color:#fff;font-family:SiemensSansGlobalCC-Roman,Helvetica Neue,Helvetica,sans-serif;font-size:.875rem;color:#fff;color:#00646e;display:inline-block;word-break:break-all}.updateValue span[data-v-81b82960]{background-color:#41aaaa}", ""]);

// exports
